module.exports = __webpack_public_path__ + "img/Kevin Cui.de09195c.jpg";